import { useEffect } from 'react';
import styled from 'styled-components';

import AiView from '../Component/AiView';
import ChannelTalk from '../../Model/Share/Network/ChannelTalk';

export default function AiPage() {
  // 채널톡 비활성화 및 복원 //
  useEffect(() => {
    ChannelTalk.shutdown();

    return () => {
      ChannelTalk.boot({ "pluginKey": "d2f4dfce-95e8-498e-aed3-84804b9d3772" });
    }
  }, []);

  return (
    <Container>
      <AiView />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;

  width: 100%;
  padding: 0 130px;
  box-sizing: border-box;
`;
